import React, { useState } from "react";
import Slider from "react-slick";

import 'aos/dist/aos.css';
import '../assets/Header.css';
import '../assets/HeroSection.css';

import EnquiryForm from "./EnquiryForm";
import Whatsapp from "./Whatsapp";

// Images
import panshetMahotsav from '../assets/imgs/hero-banner2.webp';
import sakalpuraskar from '../assets/imgs/sakal-gaurav-puraskar.webp';
import ssg2 from '../assets/events/ssg-2.webp';
import newyear from '../assets/imgs/new-year-hero.webp';
import directorsMsg from '../assets/imgs/directors-msg.png';
import Sawali from '../assets/imgs/Banner/sawali_plots.png';
import vatika from '../assets/imgs/Banner/aatmabodh_vatika.png';
import tamhini from '../assets/imgs/Banner/tamhini_.png';

import comingexpo from '../assets/imgs/Banner/coming_to_expo.png';

import lonavalleybanner from '../assets/imgs/Banner/Lonavalley_banner-image (1).png';
import waterscapebanner from '../assets/imgs/Banner/waterscape_banner-image.png';
import rivierabanner from '../assets/imgs/Banner/Riviera_greens_banner-image.png';
import donjebanner from '../assets/imgs/Banner/donje_banner-image.png';
import tamhinibanner from '../assets/imgs/Banner/tamhini_banner-image.png';

import herovideo from '../assets/Panshet/Panshet-hero.mp4';


import mountain from '../assets/Panshet/lush-mountain.png';
import waterfall from '../assets/Panshet/waterfall-.png';
import farmhouse from '../assets/Panshet/waterscape-farm.png';

import backwaters from '../assets/videos/backwaters.mp4';
import farmhousev from '../assets/videos/farm.mp4';
import mountainv from '../assets/videos/mountain.mp4';





// ✅ Custom Next Arrow
function NextArrow(props) {
    const { onClick } = props;
    return (
        <button className="custom-arrow next-arrow" onClick={onClick}>
            Next →
        </button>
    );
}

// ✅ Custom Prev Arrow
function PrevArrow(props) {
    const { onClick } = props;
    return (
        <button className="custom-arrow prev-arrow" onClick={onClick}>
            ← Prev
        </button>
    );
}

function HeroSection() {
    const [isModalVisible, setIsModalVisible] = useState(false);

    const slides = [
        // {
        //     image: comingexpo,
        //     heading: "Meets Us",
        //     subheading: "11 & 12 April-2026",
        //     bullets: ["10:00 AM to 8:00 PM"],
        //     cta1: "Enquire Now",
        // },

        {
            video: herovideo,
            heading: "Dam View Farmhouse Plots in Velhe, Pune ",
            subheading: "Just 39km from pune",
            bullets: ["50+ Acres of Gated Community"],
            cta1: "Enquire Now",
        },
        {
            video: mountainv,
            heading: "Wake up to waterfalls,mountain fog,breathtaking 270° panoramic dam view ",
            subheading: "Starting @Just ₹17 Lakhs",
            bullets: ["100+ Acres of Gated Community"],
            cta1: "Enquire Now",
        },
        {
            video: farmhousev,
            heading: "Nature-Inspired Resort style living ",
            subheading: "FRAMED BY NATURE",
            bullets: ["125 Acres of Gated Community"],
            cta1: "Enquire Now",
        },
        {
            video: backwaters,
            heading: "Wake up to Sinhagad views and a life of peace, balance & mindfulness",
            subheading: "",
            bullets: ["6 Acres of Bungalow Community"],
            cta1: "Enquire Now",
        },
        // {
        //     image: tamhinibanner,
        //     heading: "Wake Up to Tamhini’s Waterfall Views",
        //     subheading: "Live where mist, mountains, and waterfalls surround your everyday life.",
        //     bullets: ["Farmhouse plots @Tamhini"],
        //     cta1: "Enquire Now",
        // },
        // {
        //     image: Sawali,
        //     heading: "KONDHANPUR – R-ZONE BUNGALOW SOCIETY",
        //     subheading: "Just 15 minutes from the city… designed for your first bungalow lifestyle",
        //     bullets: [""],
        //     cta1: "Enquire Now",
        // },
        // {
        //     image: panshetMahotsav,
        //     heading: "Panshet Mahotsav - 23 Dec 2025",
        //     subheading: "100+ families explored Waterscape",
        //     bullets: ["Closed 50% bookings in a single day!"],
        //     cta1: "Enquire Now",
        // },
        // {
        //     image: sakalpuraskar,
        //     heading: "Samriddhi Group",
        //     subheading: "सकाळ गौरव गाथा पुरस्कार for Sustainable Development",
        //     bullets: ["Awarded on 24 June 2025"],
        //     cta1: "Enquire Now",
        // }
    ];

    const sliderSettings = {
        dots: true,
        arrows: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        swipe: true,
        touchMove: true,
        pauseOnHover: false,
        adaptiveHeight: true,

        // ✅ Attach custom arrows
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />
    };

    const handleCloseModal = () => setIsModalVisible(false);

    return (
        <>
            <div className="hero-container">
                <Slider {...sliderSettings}>
                    {slides.map((slide, index) => (
                        <div key={index} className="hero-slide active">
                            <video
                                src={slide.video}
                                alt={slide.heading}
                                className="hero-image"
                                autoPlay
                                muted
                                loop
                                playsInline
                                preload="metadata"
                            />

                            {/* <div className="hero-slide-content">
                                <h3 className="hero-heading">{slide.heading}</h3>
                                <p className="hero-subheading">{slide.subheading}</p>

                                <ul className="hero-bullets">
                                    {slide.bullets.map((point, i) => (
                                        <li key={i}>• {point}</li>
                                    ))}
                                </ul>

                                {slide.cta1 && (
                                    <div className="hero-buttons">
                                        <button
                                            className="scheduleVisit"
                                            onClick={() => setIsModalVisible(true)}
                                        >
                                            {slide.cta1}
                                        </button>
                                    </div>
                                )}
                            </div> */}
                        </div>
                    ))}
                </Slider>

                {/* MODAL */}
                {isModalVisible && (
                    <div className="h-modal-overlay" onClick={handleCloseModal}>
                        <div
                            className="h-modal-content"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                className="h-close-modal"
                                onClick={handleCloseModal}
                            >
                                ×
                            </button>
                            <EnquiryForm />
                        </div>
                    </div>
                )}
            </div>

            {/* SAMRIDDHI GROUP INTRO SECTION */}

            <section className="short-intro-sg">

                {/* LEFT SIDE - NATURE ARTWORK */}

                <div className="short-intro-sg-visual">

                    <div className="short-intro-sg-artwork">

                        {/* Decorative abstract shapes */}

                        <div className="short-intro-sg-organic-shape shape-one"></div>
                        <div className="short-intro-sg-organic-shape shape-two"></div>
                        <div className="short-intro-sg-organic-shape shape-three"></div>

                        {/* Nature headline */}

                        <div className="short-intro-sg-artwork-text">
                            <span className="short-intro-sg-artwork-small">
                                A LIFE CONNECTED TO
                            </span>

                            <h2 className="backtonature">
                                Back to
                                <br />
                                Nature<span>.</span>
                            </h2>

                            <div className="short-intro-sg-artwork-line"></div>

                            <p>
                                Where the earth feels closer
                                <br />
                                and life feels more meaningful.
                            </p>
                        </div>

                        {/* Decorative botanical circles */}

                        <div className="short-intro-sg-circle circle-one"></div>
                        <div className="short-intro-sg-circle circle-two"></div>

                    </div>

                </div>


                {/* RIGHT SIDE - CONTENT */}

                <div className="short-intro-sg-content">

                    <span className="short-intro-sg-label">
                        OUR PHILOSOPHY
                    </span>

                    <h2 className="short-intro-sg-heading">
                        More than land.
                        <br />

                        <span>
                            A way of life.
                        </span>
                    </h2>

                    <div className="short-intro-sg-divider"></div>

                    <p className="short-intro-sg-para">
                        At Samriddhi Group, we believe land is more than
                        property. It's a lifestyle, an inheritance, and a
                        personal sanctuary.
                    </p>

                    <p className="short-intro-sg-para">
                        Our projects are born from a simple vision:
                    </p>

                    <blockquote className="short-intro-sg-quote">
                        “Let nature enrich life, and let land enrich generations.”
                    </blockquote>

                    <p className="short-intro-sg-para">
                        From mango farms in Velhe to wellness retreats near
                        Lonavala and riverside escapes near Pune, every project
                        brings together peaceful living, thoughtful investment,
                        and an emotional connection with nature.
                    </p>

                    <div className="short-intro-sg-values">

                        <div className="short-intro-sg-value">
                            <span>01</span>
                            <p>Peaceful Living</p>
                        </div>

                        <div className="short-intro-sg-value">
                            <span>02</span>
                            <p>Thoughtful Investment</p>
                        </div>

                        <div className="short-intro-sg-value">
                            <span>03</span>
                            <p>Emotional Connection</p>
                        </div>

                    </div>

                </div>

            </section>

            <Whatsapp />
        </>
    );
}

export default HeroSection;